import { findErrorCode } from '@/lib/shareImport/findErrorCode';

const ERROR_KEYS = {
  MEDIASILO_PRO_REQUIRED: 'mediasilo.errors.proRequired',
  MEDIASILO_UNSUPPORTED_LINK: 'mediasilo.errors.unsupportedLink',
  MEDIASILO_PRIVATE_OR_EXPIRED: 'mediasilo.errors.privateOrExpired',
  MEDIASILO_NOT_FOUND: 'mediasilo.errors.notFound',
  MEDIASILO_NO_VIDEOS: 'mediasilo.errors.noVideos',
  MEDIASILO_NOT_READY: 'mediasilo.errors.notReady',
  MEDIASILO_API_CHANGED: 'mediasilo.errors.unavailable',
  MEDIASILO_UNAVAILABLE: 'mediasilo.errors.unavailable',
  MEDIASILO_DOWNLOAD_FAILED: 'mediasilo.errors.downloadFailed',
} as const;

export type MediasiloErrorCode = keyof typeof ERROR_KEYS;

export function getMediasiloErrorCode(value: unknown): MediasiloErrorCode | null {
  return findErrorCode(value, ERROR_KEYS);
}

export function getMediasiloErrorKey(error: unknown): string {
  return ERROR_KEYS[getMediasiloErrorCode(error) ?? 'MEDIASILO_UNAVAILABLE'];
}
